import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Layout from "../../../components/dashboard-layout/layout";
import ViewDetailsComponent, {
  TopicType,
  ViewTopic,
} from "../../../components/view-details.component";
import {
  AlertType,
  useDashboardStore,
} from "../../dashboard/store/dashboard.store";
import { getFuturePageById } from "../apis/future-page.api";
import DeleteFuturePageDialog from "../dialogs/delete-future-page.dialog";
import EditFuturePageDialog from "../dialogs/edit-future-page.dialog";
import { FuturePageDetailsEntity } from "../entities/future-page-details.entity";
import { FuturePageDetailsModel } from "../models/future-page-details.model";

const topics: ViewTopic[] = [
  {
    title: "Cover Image",
    contentKey: "imageUrl",
    type: TopicType.image,
  },
  {
    title: "Description",
    contentKey: "description",
    type: TopicType.string,
  },
  {
    title: "Year",
    contentKey: "pageYear",
    type: TopicType.string,
  },
  {
    title: "Created At",
    contentKey: "createdAt",
    type: TopicType.dateTime,
  },
  {
    title: "Last Update",
    contentKey: "updatedAt",
    type: TopicType.dateTime,
  },
];

export default function ViewFuturePage() {
  const [searchParams] = useSearchParams();
  const [futurePage, setFuturePage] = useState<FuturePageDetailsEntity>();
  const [editModalOpen, setEditModalOpen] = useState<boolean>(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
  const initEffect = useRef<boolean>(false);
  const setAlert = useDashboardStore((state) => state.setAlert);

  useEffect(() => {
    if (initEffect.current === false) {
      const id = searchParams.get("id");
      if (id) {
        getFuturePageById(id)
          .then((response) => {
            const newPastPage = new FuturePageDetailsModel(
              response.data
            ).toEntity();
            setFuturePage(newPastPage);
          })
          .catch((error) => {
            setAlert({
              message: error.response.data.message,
              type: AlertType.error,
            });
          });
      }
    }
    return () => {
      initEffect.current = true;
    };
  }, [searchParams, setAlert]);

  return (
    <Layout>
      {futurePage && (
        <EditFuturePageDialog
          open={editModalOpen}
          setOpen={setEditModalOpen}
          futurePage={futurePage}
        />
      )}
      {futurePage && (
        <DeleteFuturePageDialog
          open={deleteModalOpen}
          setOpen={setDeleteModalOpen}
          futurePage={futurePage}
        />
      )}
      <div className="flex">
        <div className="flex-grow px-4 sm:px-0">
          <h3 className="text-base font-semibold leading-7 text-gray-900">
            Future Page Details
          </h3>
        </div>
        <button
          className="mx-1 rounded-md bg-indigo-600 px-3 py-1.5 text-center text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          onClick={() => setEditModalOpen(true)}
        >
          Edit
        </button>
        <button
          className="mx-1 rounded-md bg-red-600 px-3 py-1.5 text-center text-sm font-semibold leading-6 text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          onClick={() => setDeleteModalOpen(true)}
        >
          Delete
        </button>
      </div>

      {futurePage && (
        <ViewDetailsComponent topics={topics} content={futurePage} />
      )}
    </Layout>
  );
}
